import React from "react";
import Picker,{SKIN_TONE_MEDIUM_DARK} from 'emoji-picker-react';

type Props = {
  handleEmoji:Function;
}

type State={
  chosenEmoji:any;
  messageText:any;
}
class URemojiMessage extends React.Component<Props, State> {

  constructor(props: any) {
    super(props);
    this.state = {
      chosenEmoji: "",
      messageText: ""
    };
  }
  
  /**
   * Search emoji
   * @param data 
   */
  setChosenEmoji=(data:any) => {
    this.props.handleEmoji(data.emoji);
  }

  /**
   * function called we click emoji to load the emoji
   * @param event 
   * @param emojiObject 
   */
  onEmojiClick = (event:any, emojiObject:any) => {
    this.setChosenEmoji(emojiObject);
  };
  

  render() {
    return (
      <div>
        <Picker skinTone={SKIN_TONE_MEDIUM_DARK} preload={true} onEmojiClick={this.onEmojiClick} />
      </div>
    );
  }

}

export {
  URemojiMessage
};